import { useIntl } from 'react-intl';

import InputFormikField from '../forms/InputFormikField';
import TextareaFormikField from '../forms/TextareaFormikField';
import DateFormikField from '../forms/DateFormikField';
import NumberInputFormikField from '../forms/NumberInputFormikField';
import CheckboxFormikField from '../forms/CheckboxFormikField';
import ComboboxFormikField from '../forms/ComboboxFormikField';

import { enUSFormatExcludingTime } from '../../services/items';

const DynamicFormProperty = ({
    groupId,
    property: {
        id,
        name,
        type,
        propertyValues,
        readOnly,
        minimum,
        maximum,
        increment,
        multiLine,
        minDate,
        maxDate,
        decimalPlaces,
    },
}) => {
    const intl = useIntl();

    switch (type) {
        case 'TextBox':
            return (
                <>
                    {multiLine ? (
                        <TextareaFormikField
                            id={`properties.group_${groupId}.field_${id}`}
                            name={`properties.group_${groupId}.field_${id}`}
                            label={name}
                            isReadOnly={readOnly}
                            isDisabled={readOnly}
                        />
                    ) : (
                        <InputFormikField
                            id={`properties.group_${groupId}.field_${id}`}
                            name={`properties.group_${groupId}.field_${id}`}
                            label={name}
                            isReadOnly={readOnly}
                            isDisabled={readOnly}
                            type="text"
                        />
                    )}
                </>
            );
        case 'ComboBox':
            return (
                <ComboboxFormikField
                    id={`properties.group_${groupId}.field_${id}`}
                    name={`properties.group_${groupId}.field_${id}`}
                    label={name}
                    options={propertyValues}
                    labelKey="value"
                    valueKey="value"
                    isDisabled={readOnly}
                    placeholderValue=""
                    placeholderLabel={intl.formatMessage({ id: 'common_forms_select_option' })}
                />
            );
        case 'NumericUpDown':
            return (
                <NumberInputFormikField
                    id={`properties.group_${groupId}.field_${id}`}
                    name={`properties.group_${groupId}.field_${id}`}
                    label={name}
                    isDisabled={readOnly}
                    min={minimum || undefined}
                    max={maximum || undefined}
                    step={increment || undefined}
                    precision={decimalPlaces}
                />
            );
        case 'CheckBox':
            return (
                <CheckboxFormikField
                    id={`properties.group_${groupId}.field_${id}`}
                    name={`properties.group_${groupId}.field_${id}`}
                    isDisabled={readOnly}
                >
                    {name}
                </CheckboxFormikField>
            );
        case 'MonthCalendar':
            return (
                <DateFormikField
                    id={`properties.group_${groupId}.field_${id}`}
                    name={`properties.group_${groupId}.field_${id}`}
                    label={name}
                    minDate={minDate}
                    maxDate={maxDate}
                    isDisabled={readOnly}
                    dateFormat={enUSFormatExcludingTime}
                    showTimeInput={false}
                />
            );
        default:
            return null;
    }
};

export default DynamicFormProperty;
